import React from 'react'
import { useState } from "react";
import {ReactComponent as Muted} from '../../../assets/muted.svg';
import {ReactComponent as Unmuted } from '../../../assets/unmuted.svg';
import '../../../styles/containers/Prayer/components/prayer-music.scss';
// import Sound from 'react-sound';

// const useAudio = url => {
//   const [audio] = useState(new Audio(url));
//   const [playing, setPlaying] = useState(false);

//   const toggle = () => setPlaying(!playing);

//   useEffect(() => {
//       playing ? audio.play() : audio.pause();
//     },
//     [playing]
//   );

//   useEffect(() => {
//     audio.addEventListener('ended', () => setPlaying(true));
//     return () => {
//       audio.removeEventListener('ended', () => setPlaying(false));
//     };
//   }, []);

//   return [playing, toggle];
// };

function PrayerMusic({ link }) {
  // const [playing, toggle] = useAudio(link);
  const [playing, setPlaying] = useState(true);
  const handleClick = () => {
      setPlaying(!playing);
  }
  return (
    // <div>
    //   <button onClick={toggle}>{playing ? "Pause" : "Play"}</button>
    // </div>
    // <Sound url={link} playStatus={Sound.status.PLAYING} loop={true} autoLoad={true}/>
    // <embed src={link} loop={'true'} autostart={'true'} width="0" height="0"></embed>
    // <bgsound src={link} loop='infinite'/>
    <span onClick={handleClick} className='prayer-music-container'>
      {playing? <Unmuted/>: <Muted/>}
      <audio autoPlay="autoplay" loop muted={!playing}>
        <source src={link} type='audio/mp3'/>     
      </audio>
    </span>
  );
};


export default PrayerMusic